import React from "react";
import HomeSlider from "./HomeSlider";
import HomeBanner from "./HomeBanner";
import HomeProduct from "./HomeProduct";
import Blog from "./Blog";
import MiddleBanner from "./MiddleBanner";
import FeaturesSection from "../../components/FeaturesSection";


const Home = () => {
  return (
    <>
      <HomeSlider />
	  <HomeBanner/>
	  <HomeProduct/>
    <MiddleBanner/>
    <FeaturesSection/>
   <Blog/>
    </>
  );
};

export default Home;
